document.addEventListener("DOMContentLoaded", function () {
  const navLinks = document.querySelectorAll(".main-links > li > a");

  navLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      const parentLi = this.parentElement;
      const submenu = parentLi.querySelector(".sub-menu-links");

      if (submenu && window.innerWidth < 900) {
        e.preventDefault();
        parentLi.classList.toggle("submenu-open");
        submenu.style.display = "block";
      }
    });
  });
});
const hamburger = document.getElementById("hamburger");
const mobileMenu = document.getElementById("mobileMenu");

hamburger.addEventListener("click", () => {
  mobileMenu.style.display =
    mobileMenu.style.display === "block" ? "none" : "block";
});

// document.addEventListener(
//   "DOMContentLoaded",
//   $(".grid").isotope({
//     itemSelector: ".grid-item",
//     layoutMode: "masonry",
//     masonry: {
//       columnWidth: ".grid-item",
//       horizontalOrder: true,
//       gutter: 18,
//     },
//   })
// );
// Put your application javascript here
// const headers = document.querySelectorAll(".accordion-header");
// const allContents = document.querySelectorAll(".accordion-content");
// headers.forEach((header) => {
//   header.addEventListener("click", function () {
//     const content = this.nextElementSibling;
//     // Toggle the current accordion section
//     content.classList.remove("content-inactive");
//     if (content.style.maxHeight) {
//       content.style.maxHeight = null;
//       content.classList.add("inactive-content");
//       // Close the section
//       content.previousElementSibling.classList.add("inactive-title");
//     } else {
//       // Close all other sections
//       const allContents = document.querySelectorAll(".accordion-content");
//       allContents.forEach((item) => {
//         item.style.maxHeight = null;
//         item.previousElementSibling.classList.add("inactive-title");
//         item.classList.add("inactive-content");
//       });
//       // Open the clicked section
//       content.style.maxHeight = content.scrollHeight + "px";
//       content.previousElementSibling.classList.remove("inactive-title");
//       content.classList.remove("inactive-content");
//     }
//   });
// });
// console.log(78798);
const headers = document.querySelectorAll(".accordion-header");
const allContents = document.querySelectorAll(".accordion-content");

headers.forEach((header) => {
  header.addEventListener("click", function () {
    const content = this.nextElementSibling;

    const isOpen = content.style.maxHeight;

    // Close all sections
    allContents.forEach((item) => {
      item.style.maxHeight = null;
      item.previousElementSibling.classList.add("inactive-title");
      item.classList.add("inactive-content");
    });

    // If it wasn't open before, open this one
    if (!isOpen) {
      content.style.maxHeight = content.scrollHeight + "px";
      this.classList.remove("inactive-title");
      content.classList.remove("inactive-content");
    } else {
      // If everything is now closed, remove inactive-* classes
      const allClosed = Array.from(allContents).every(
        (item) => !item.style.maxHeight
      );

      if (allClosed) {
        allContents.forEach((item) => {
          item.classList.remove("inactive-content");
          item.previousElementSibling.classList.remove("inactive-title");
        });
      }
    }
  });
});
// document.addEventListener("DOMContentLoaded", function () {
//   const images = document.querySelectorAll("#image-container .section-image");
//   console.log(images);
//   let current = 0;
//   const container = document.getElementById("image-container");
//   container.addEventListener("click", function () {
//     images[current].style.display = "none";
//     current = (current + 1) % images.length;
//     images[current].style.display = "block";
//   });
// });

(function () {

  ///cart functions
const openCartBtn = document.querySelectorAll(".open-cart");
const cartDrawer = document.getElementById("cart-drawer");
const closeCartBtn = document.getElementById("close-cart");

if(!openCartBtn){
  return;
}
openCartBtn.forEach((el) => {
  if(el.classList.contains('unavailable')){
    return false;
  }
  el.addEventListener("click", function () {
    fetch("/cart.js") // Shopify's cart object
      .then((response) => response.json())
      .then((cart) => {
        const cartDrawer = document.getElementById("cart-drawer");
        const cartContent = cartDrawer.querySelector(".cart-content");
        // Simple rendering (you can enhance this with better HTML)
        // if (cart.items.length > 0) {
        //   cartContent.innerHTML = cart.items
        //     .map(
        //       (item) => `
        //     <div>
        //       <p>${item.title}</p>
        //       <p>Quantity: ${item.quantity}</p>
        //       <p>Price: ₹${item.final_price / 100}</p>
        //     </div>
        //   `
        //     )
        //     .join("");
        // } else {
        //   cartContent.innerHTML = "<p>Your cart is empty.</p>";
        // }
        console.log('sd1');
        cartDrawer.classList.add("active");
        document.body.classList.add("cart-active");

        //cartDrawer.classList.remove("hidden");
      });
  });
});

// Optional: close cart logic
document.addEventListener("click", function (e) {
  const drawer = document.getElementById("cart-drawer");
  const closebtn = document.getElementById("close-btn");
  if (e.target.classList.contains("open-cart")) {
    drawer.classList.remove("active");
    setTimeout(() => drawer.classList.add("hidden"), 300); // delay for transition
  }
});

closeCartBtn.addEventListener("click", () => {
  cartDrawer.classList.remove("active");
  document.body.classList.remove("cart-active");
  //setTimeout(() => cartDrawer.classList.add("hidden"), 300);
});

})();




// const cartDrawer = document.getElementById("cart-drawer");
// const closeCartBtn = document.getElementById("close-cart");
// console.log(closeCartBtn);
// // Open Side Cart on Click
// cartBtn.addEventListener("click", () => {
//   fetch("/cart.js")
//     .then((res) => res.json())
//     .then((cart) => {
//       const cartContent = cartDrawer.querySelector(".cart-content");
//       // if (cart.items.length) {
//       //   cartContent.innerHTML = cart.items
//       //     .map(
//       //       (item) => `
//       //     <div style="padding: 10px; border-bottom: 1px solid #eee;">
//       //       <p><strong>${item.product_title}</strong></p>
//       //       <p>Qty: ${item.quantity}</p>
//       //       <p>Price: ₹${item.final_price / 100}</p>
//       //     </div>
//       //   `
//       //     )
//       //     .join("");
//       // } else {
//       //   cartContent.innerHTML =
//       //     '<p style="padding: 20px;">Your cart is empty.</p>';
//       // }

//       cartDrawer.classList.add("active");
//     });
// });

// // Close Side Cart on Close Button Click
// closeCartBtn.addEventListener("click", () => {
//   cartDrawer.classList.remove("active");
// });

// full page
// new fullpage("#main-content", {
//   //options here
//   easingcss3: "cubic-bezier(0.175, 0.885, 0.320, 1.275)",
//   scrollHorizontally: true,
// });

// let isFullpageActive = true;

// new fullpage("#main-content", {
//   sectionSelector: ".section",
//   // css3: true,
//   // scrollingSpeed: 700,
//   // autoScrolling: false,
//   // fitToSection: true,
//   // fitToSectionDelay: 600,
//   // easing: "easeInOutCubic",
//   // easingcss3: "ease",
//   // fitToSection: false,
//   // autoScrolling: true,
//   scrollOverflow: true,
//   // navigation: true,
//   // afterLoad: function (origin, destination, direction) {
//   //   const lastIndex = fullpage_api.getSectionCount() - 1;
//   //   // Disable fullPage on last section
//   //   if (destination.index === lastIndex && isFullpageActive) {
//   //     fullpage_api.setAutoScrolling(false);
//   //     fullpage_api.setFitToSection(false);
//   //     isFullpageActive = false;
//   //   }
//   // },
//   // onLeave: function (origin, destination, direction) {
//   //   const lastIndex = fullpage_api.getSectionCount() - 1;
//   //   // Re-enable fullPage when scrolling up into last section from normal scroll area
//   //   if (!isFullpageActive && origin.index === lastIndex && direction === "up") {
//   //     fullpage_api.setAutoScrolling(true);
//   //     fullpage_api.setFitToSection(true);
//   //     isFullpageActive = true;
//   //     // Scroll to the last fullPage section for a smooth experience
//   //     fullpage_api.moveTo(lastIndex + 1);
//   //   }
//   // },
// });
